import { helpers } from "../../common/lib";
import getInitialState from "../get-initial-state";
import { actionTypes } from "./actions";

export default function (state = getInitialState.list(), action) {
  switch (action.type) {
    case actionTypes.AUDIT_COMMENT_GET_REQUEST:
    case actionTypes.AUDIT_COMMENT_POST_REQUEST:
    case actionTypes.AUDIT_COMMENT_PATCH_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }

    case actionTypes.AUDIT_COMMENT_GET_SUCCESS: {
      const auditComments = action.payload;
      return helpers.getListReducer(state, auditComments);
    }

    case actionTypes.AUDIT_COMMENT_POST_SUCCESS: {
      const { auditComment } = action.payload;
      return {
        ...state,
        loading: false,
        data: [auditComment, ...state.data]
      };
    }

    case actionTypes.AUDIT_COMMENT_PATCH_SUCCESS: {
      const { auditComment } = action.payload;
      const updatedData = state.data.map((comment) =>
        comment.id === auditComment.id ? auditComment : comment
      );
      return {
        ...state,
        loading: false,
        data: updatedData
      };
    }

    case actionTypes.AUDIT_COMMENT_GET_FAILURE:
    case actionTypes.AUDIT_COMMENT_POST_FAILURE:
    case actionTypes.AUDIT_COMMENT_PATCH_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      };
    }

    default:
      return state;
  }
}
